module.exports = __webpack_public_path__ + "static/media/iphone-11-pro.185cd671.svg";